import React from 'react';
import { useIntl } from 'react-intl';

import Button from 'carbon-react/lib/components/button';

import { ExtendedWorkspaceListItem } from '@futrli/views/operations/workspaces/processors/workspacesList';

import { useWorkspacesActions } from '../../context/workspaces-actions-context/workspaces-actions-context';

interface WorkspaceSettingsButtonProps {
  workspace: ExtendedWorkspaceListItem;
}

export const WorkspaceSettingsButton = ({ workspace }: WorkspaceSettingsButtonProps) => {
  const intl = useIntl();
  const { handleWorkspaceSettingsClick } = useWorkspacesActions();

  return (
    <Button
      ml={1}
      buttonType="tertiary"
      size="small"
      iconType="settings"
      aria-label={intl.formatMessage({
        id: 'workspaces.workspace_settings',
        defaultMessage: 'Workspace settings'
      })}
      onClick={() => handleWorkspaceSettingsClick(workspace)}
    />
  );
};
